@if (requestState === 'loading') {
<div class="d-flex justify-content-center">
  <app-loader></app-loader>
</div>
} @else {

  @if (requestState === 'error') {

    <div class="alert alert-danger">{{'indicators.error.generic' | translate}}</div>
  
} @else {

    <div class="animated fadeIn w-100 h-100 indicator-values-layout">

      <div class="indicator-values-section">
        <input type="hidden" [(ngModel)]="selectedSubjects" saveInputValue="subject"/>
        <app-chips-autocomplete [placeholder]="'indicators.subject' | translate"
                                [choices]="subjects"
                                [(selectedOptions)]="selectedSubjects"
        ></app-chips-autocomplete>
      </div>

      <div class="indicator-values-section">
        <input type="hidden" [(ngModel)]="selectedPeriods" saveInputValue="period"/>
        <app-chips-autocomplete [placeholder]="'indicators.period' | translate"
                                [choices]="periods"
                                [(selectedOptions)]="selectedPeriods"
        ></app-chips-autocomplete>
      </div>

      <div class="indicator-values-section indicator-chart-type-row">
        <mat-form-field class="w-100 indicator-filter-field" floatLabel="always" subscriptSizing="dynamic">
          <mat-label>{{'filters.chartType.title' | translate}}</mat-label>
          <mat-select [(ngModel)]="chartType" (ngModelChange)="onChartTypeChange()" saveInputValue="chartType"
            aria-haspopup="dialog"
            role="listbox"
            saveInputValue="short">
            @for (option of chartTypes; track option) {
<mat-option [value]="option.value">
              {{option.label | translate}}
            </mat-option>
}
            @if (chartTypes.length <= 0) {
<mat-option [disabled]="true">No data</mat-option>
}
          </mat-select>
        </mat-form-field>
      </div>

      @if (selectedSubjects && selectedPeriods && indicator) {
<div class="indicator-chart-container">
        <app-indicator-chart-component
          [short]="indicator.short"
          [breakdown]="indicator.breakdown"
          [unit]="indicator.unit"
          [values]="indicatorValues"
          [subjects]="selectedSubjects"
          [periods]="selectedPeriods"
          [chartType]="chartType"
        ></app-indicator-chart-component>
      </div>
}

    </div>
  
}


}
